<template>
    <div>
      <img src="/static/img/app/logo_gorsh.svg?v=1.0" class="logo-login" />

      <div class="table">
        <div class="cell">

          <div class="box-login">

            <form method="post" @submit.prevent="loginForm" lang="es">

              <h4>WHOLESELLERS PLATFORM</h4>
              <h1>Tienda Mayorista</h1>
              <!-- <h1>Experimentá el color de Gorsh.</h1> -->
              <p>
                Accedé con tu cuenta de Gorsh para usuarios mayoristas.
              </p>
              <p style="color: red">
                {{error}}
              </p>

              <input class="usuario" name="user" type="text" placeholder="Username" v-model="email" />
              <input class="password" name="pass" type="password" placeholder="Password" v-model="password"  />

              <br><br>
              <input type='submit' class="submit btn-comenzar" value="INGRESAR" name='boton'>

              <ul class="login-links">

                <li>
                  <router-link to="register">&bull; ¿No estas registrado? Solicita tu acceso.</router-link>
                </li>

                <li>
                  <a href="https://gorsh.net/forgot">&bull; Olvidé mi contraseña.</a>
                </li>

              </ul>


            </form>

          </div>

        </div>
      </div>

      <div v-if="isMobile()" class="PortraitBackgroundImage"></div>

      <video v-else id="videoPortada" class="PortraitBackgroundVideo" muted="muted" loop="loop" autoplay="autoplay" preload="auto">
          <source type="video/mp4" src="static/video/video.2026.mp4?v=1"></source>
      </video>

    </div>
</template>

<script>
import Mobile from "./../mixing/mobile";
export default {
    name: "LoginPage",
    data: function() {
        return {
            email: "",
            password: "",
            error: "",
            pending: false
        };
    },
    mixins: [Mobile],
    methods: {
        loginForm() {
            this.error = "";
            this.pending = true;

            this.$store
                .dispatch("login", this)
                .then(() => {
                    this.pending = false;
                    this.$router.push({ name: "Home" });
                })
                .catch(err => {
                    console.log(err);
                    this.pending = false;
                    this.error = err;
                });
        }
    },
    mounted() {
        $("body")
            .removeClass()
            .addClass("login");
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue